import { render, staticRenderFns } from "./ViewLinkQuestionAnswer.vue?vue&type=template&id=6d6138a4"
import script from "./ViewLinkQuestionAnswer.vue?vue&type=script&lang=js"
export * from "./ViewLinkQuestionAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports